<script>
  import { format } from "date-fns"
  import { reactive } from "vue"
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  // import { getCityCode } from "../getAddressByCep";
  import Modal from "@/core/components/NewModal.vue"
  import ResponsiveTable from "@/core/components/table/ResponsiveTable"
  import { mask } from "@/core/services/helpers"
  import passesTypes from "../passesTypes.js"
  import { TipoBeneficiario } from "./StepOne.vue"

  export default {
    components: {
      Breadcrumbs,
      ResponsiveTable,
      Modal,
    },

    data: () => ({
      TipoBeneficiario,
      id: null,
      screenType: null,
      title: "SPL Navegantes",
      crumbs: [
        { name: "Início", path: "index" },
        { name: "SPL Navegantes", path: "spl-navegantes.index" },
        { name: "Editar", path: "spl-navegantes.edit" },
        { name: "Solicitação de Passe", path: "spl-navegantes.documents" },
      ],
      beneficiario: {
        cep: "",
        complement: null,
        contato_filicao: null,
        contatos: null,
        controle_registro: [],
        district: "",
        doacao: [],
        document: "",
        dtcadastro: "",
        dtnascimento: "",
        filicao: [],
        fljornada: false,
        idsituacao: 0,
        imagem: null,
        idbeneficiario: null,
        nmnome: "",
        number: 0,
        numunicipio: {
          name: "",
        },
        street: "",
        tpbeneficiario: "1",
        tpbeneficiario_inicial: "1",
        tplocomocao: "1",
        tppasse: "1",
      },
      instituicao: {},
      dataExpiracao: new Date(),
      tipoLocomocao: [
        { name: "Pedestre", value: 1, selected: false, quantidade: 0 },
        { name: "Ciclista", value: 2, selected: false, quantidade: 0 },
        { name: "Motociclista", value: 3, selected: false, quantidade: 0 },
      ],
      tipoPasse: [
        { name: "Físico", value: 1 },
        { name: "Eletronico", value: 2 },
      ],
      locomocaoSelecionada: 1,
      tpPasseSelecionado: 1,
      ispendencia: false,
      observacao: "",
      getBeneficiarioLoading: false,
      obs: null,
      obs_pendencia: null,
      situations: [
        { id: 1, label: "INICIADO", color: "#DC904A" },
        { id: 2, label: "ANALISADO", color: "#028C4A" },
        { id: 3, label: "ATIVO", color: "#028C4A" },
        { id: 4, label: "VENCIDO", color: "#DA3E3E" },
        { id: 5, label: "PENDENTE", color: "#DC904A" },
        { id: 6, label: "CANCELADO", color: "#DA3E3E" },
        { id: 7, label: "A VENCER", color: "#DA3E3E" },
      ],
      passeForm: {
        quantidade: 0,
        jornada12x36: 0,
      },
      hasErrors: false,
      headers: [
        "Mês de Vigência",
        "Quantidade",
        "Tipo de Beneficiário",
        "Empresa",
        "Data da Entrega",
        "Observação",
      ],
      passes: reactive([]),
      passes_total: [],
      status: "pending",
      loading: false,
      page: 1,
      passesTypes,
      passesOptions: null,
      selectedOption: null,
    }),
    computed: {
      pagination() {
        return {
          current_page: 1,
          first_page_url:
            "https://scmobi.sie.sc.gov.br/api/registry/person/organizations?page=1",
          from: 1,
          last_page: 1,
          last_page_url:
            "https://scmobi.sie.sc.gov.br/api/registry/person/organizations?page=1",
          next_page_url: null,
          path: "https://scmobi.sie.sc.gov.br/api/registry/person/organizations",
          // per_page: 15,
          per_page: 6,
          prev_page_url: null,
          to: 2,
          total: this.passes_total.length,
        }
      },
    },
    mounted() {
      this.beneficiario = JSON.parse(sessionStorage.getItem("beneficiarioEdit"))
      this.instituicao = JSON.parse(
        sessionStorage.getItem("beneficiarioInstituicao")
      )
      this.passeForm.jornada12x36 = this.beneficiario.fljornada || 0
      this.setPassesOptions()
      const latestDoacoes = this.getLatestMonthDoacoes(this.beneficiario.doacao)
      if (latestDoacoes?.length) {
        if(latestDoacoes[0].codpasses){
          this.selectedOption = latestDoacoes[0].codpasses
          this.setPasses()
        }else {
          const totals = {}
  
          for (const doacao of latestDoacoes) {
            totals[doacao.tplocomocao] =
              (totals[doacao.tplocomocao] || 0) + doacao.nupasses
          }
  
          for (const item of this.tipoLocomocao) {
            const quantidade = totals[item.name] || 0
            item.selected = quantidade > 0
            item.quantidade = quantidade
          }
        }
      }

      this.obs = sessionStorage.getItem("obs")
      this.id = this.$route.params.id
      this.screenType = this.$route.params.screenType
      this.tpPasseSelecionado = this.beneficiario.tppasse

      document.title = `${this.title} - ${process.env.VUE_APP_TITLE}`

      this.getHistoricoPasses()

      this.locomocaoSelecionada = this.beneficiario.tplocomocao
    },
    methods: {
      format,
      mask,
      setPassesOptions() {
        let jornada = this.passeForm.jornada12x36
        if (this.beneficiario.tpbeneficiario === "2") {
          switch (jornada) {
            case 0:
              this.passesOptions = this.passesTypes[0]
              this.passeForm.quantidade = 50
              break
            case 1:
              this.passesOptions = this.passesTypes[1]
              this.passeForm.quantidade = 32
              break
            case 2:
              this.passesOptions = this.passesTypes[2]
              this.passeForm.quantidade = 20
              break
            default:
              this.passesOptions = this.passesTypes[0]
              this.passeForm.quantidade = 50
              break
          }
        } else {
          switch (jornada) {
            case 0:
              this.passesOptions = this.passesTypes[3]
              this.passeForm.quantidade = 40
              break
            case 1:
              this.passesOptions = this.passesTypes[4]
              this.passeForm.quantidade = 25
              break
            case 2:
              this.passesOptions = this.passesTypes[5]
              this.passeForm.quantidade = 16
              break
            default:
              this.passesOptions = this.passesTypes[3]
              this.passeForm.quantidade = 40
              break
          }
        }
        for (const locomocao of this.tipoLocomocao) {
          locomocao.quantidade = 0
          locomocao.selected = false
        }
      },
      getSituation(situationId) {
        if (situationId) {
          return this.situations.find((item) => item.id === situationId)
        }
      },
      getLatestMonthDoacoes(doacoes) {
        if (!doacoes.length) {
          return []
        }

        // Extract YYYY-MM
        const months = doacoes.map((d) => d.dtcadastro.slice(0, 7))

        const latestMonth = months.sort().at(-1)

        return doacoes.filter((d) => d.dtcadastro.startsWith(latestMonth))
      },
      getMaxQuantidade() {
        if (this.passeForm.jornada12x36) {
          return 30
        }
        if (this.beneficiario.tpbeneficiario === "2") {
          return 50
        }
        return 40
      },
      getTypeLabel(type) {
        switch (type) {
          case TipoBeneficiario.ESTUDANTE.toString():
            return "Estudante"
          case TipoBeneficiario.TRABALHADOR.toString():
            return "Trabalhador"
          case TipoBeneficiario.ESTAGIARIO.toString():
            return "Estagiário"
          default:
            return "Trabalhador"
        }
      },
      goBack() {
        this.$router.push({
          name: "spl-navegantes.edit",
          id: this.id,
        })
      },
      dataMap(data) {
        if (data.length > 0) {
          return data.map((item) => ({
            mesvigencia: item.nmmesvigencia,
            quantidade: item.nupasses,
            tipo_beneficiario: item.tplocomocao,
            dt_entrega:
              item.nupasses && item.dtalteracao
                ? format(new Date(item.dtalteracao), "dd/MM/yyyy")
                : "",
            empresa: item.nminstituicao,
            observacao: item.deobservacao,
          }))
        }
        return []
      },
      setPasses() {
        const selecionado = this.passesOptions.find(
          (i) => i.name === this.selectedOption
        )
        if (selecionado) {
          for (const locomocao of this.tipoLocomocao) {
            if (selecionado.values.includes(locomocao.value)) {
              locomocao.selected = true
              locomocao.quantidade = selecionado.quantidade
            } else {
              locomocao.selected = false
              locomocao.quantidade = 0
            }
          }
        }
        this.$refs.passesModal.hide()
      },
      updatePasses(value) {
        const locomocaoChanged = this.tipoLocomocao.find(
          (i) => i.value === value
        )
        const maxQuantidade = this.getMaxQuantidade()
        if (locomocaoChanged.selected) {
          locomocaoChanged.quantidade = maxQuantidade
        } else {
          locomocaoChanged.quantidade = 0
        }
      },
      updatePassesQuantity(value, type) {
        const max = this.getMaxQuantidade()
        const current = this.tipoLocomocao.find((l) => l.value === type)

        // Normalize input
        current.quantidade = Math.max(0, Number(value))

        // Force non-selected to 0
        for (const l of this.tipoLocomocao) {
          if (!l.selected) {
            l.quantidade = 0
          }
        }

        // Clamp current if it exceeds max alone
        if (current.quantidade >= max) {
          current.quantidade = max
          for (const l of this.tipoLocomocao) {
            if (l.value !== type) {
              l.quantidade = 0
            }
          }
          return
        }

        const others = this.tipoLocomocao.filter(
          (l) => l.selected && l.value !== type
        )

        if (!others.length) {
          return
        }

        const remaining = max - current.quantidade
        const equal = Math.floor(remaining / others.length)
        let remainder = remaining % others.length

        for (const l of others) {
          l.quantidade = equal + (remainder > 0 ? 1 : 0)
          if (remainder > 0) {
            remainder -= 1
          }
        }
      },
      isNullOrEmpty(value) {
        return value === null || value === "" || value === 0
      },
      isFormValid() {
        let value =
          this.tipoLocomocao[0].quantidade +
          this.tipoLocomocao[1].quantidade +
          this.tipoLocomocao[2].quantidade
        if (
          !this.tipoLocomocao.some((i) => i.selected) ||
          (this.isNullOrEmpty(value) && this.screenType === "passes") ||
          (this.isNullOrEmpty(value) && this.screenType === "passes") ||
          (this.ispendencia === true &&
            (this.obs_pendencia === "" || this.obs_pendencia === undefined))
        ) {
          this.hasErrors = true
        } else {
          this.hasErrors = false
        }
      },
      async submit() {
        if (this.screenType === "passes") {
          await this.submitPasses()
        } else {
          await this.submitDocumentos()
        }
      },
      async submitDocumentos() {
        this.isFormValid()
        if (this.hasErrors) {
          this.$toast.error({
            title: "Erro",
            message: "Verifique os campos obrigatórios!",
          })
        } else {
          await this.postDocuments()
          this.handlePasses()
        }
      },
      async postDocuments() {
        const response = await this.$axios
          .put(
            `/api/spl-navegantes/beneficiarios/editar/documentos/${this.beneficiario.idbeneficiario}`,
            {
              ispendencia: this.ispendencia,
              tplocomocao: this.tipoLocomocao,
              deobservacao: this.obs_pendencia,
            }
          )
          .then((resp) => resp.data)
        if (response?.mensagem) {
          this.$toast.error({
            title: "Erro",
            message: response.mensagem,
          })
        } else {
          sessionStorage.clear()
          this.$toast.success({
            title: "OK",
            message: "Documentos entregues com sucesso",
          })
          this.$router.push({ name: "spl-navegantes.show" })
        }
      },
      async submitPasses() {
        this.isFormValid()
        if (this.hasErrors) {
          this.$toast.error({
            title: "Erro",
            message: "Verifique os campos obrigatórios!",
          })
        } else if (this.selectedOption === null){
          this.$toast.error({
            title: "Erro",
            message: "Selecione um tipo de passe",
          })
        } else {
          await this.postPasses()
          this.handlePasses()
        }
      },
      async postPasses() {
        try {
          await this.$axios.put(
            `/api/spl-navegantes/beneficiarios/editar/passes/${this.beneficiario.idbeneficiario}`,
            {
              doacoes: this.tipoLocomocao.map((i) => ({
                nupasses: i.quantidade,
                tplocomocao: i.value,
                selected: i.selected,
                tppasse: this.tpPasseSelecionado,
                fljornada: this.passeForm.jornada12x36 || 0,
              })),
              ispendencia: this.ispendencia,
              deobservacao: this.obs,
              codpasses: this.selectedOption,
            }
          )
          sessionStorage.clear()
          this.$toast.success({
            title: "OK",
            message: "Passes entregues com sucesso",
          })

          this.$router.push({ name: "spl-navegantes.show" })
        } catch (error) {
          this.$toast.error({
            message: "Error",
          })
        }
      },
      handlePasses() {
        this.$Progress.start()
        this.$router.push({
          name: "spl-navegantes.edit",
          params: { id: this.id },
        })
        this.$Progress.finish()
      },
      async getHistoricoPasses() {
        const url = `/api/spl-navegantes/beneficiarios/historico/${this.id}`
        const { data } = await this.$axios.get(url, {
          take: "20000",
        })

        this.passes_total = data
        this.passes = this.passes_total.slice(0, 6)
        this.pagination.total = this.passes_total.length
      },
      changePage(page) {
        if (page !== this.page) {
          this.passes = this.passes_total.slice((page - 1) * 6, page * 6)
          this.page = page
        }
      },
    },
  }
</script>
<template>
  <div class="w-full w-full bg-white">
    <portal-target name="modals" multiple/>
    <div class="px-2 my-4 sm:px-6">
      <div class="px-2 my-4 sm:px-6">
        <Breadcrumbs class="mb-8" :crumbs="crumbs"/>
      </div>

      <div class="bg-gray-light lg:max-w-full my-4">
        <div class="lg:max-w-full my-4">
          <div
            class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
          >
            <span class="mt-2 text-base uppercase text-green-base">
              Controle de Registro
            </span>
          </div>
        </div>

        <template v-if="getBeneficiarioLoading">
          <div class="px-4">Carregando...</div>
        </template>
        <template v-else>
          <div class="grid gap-5 grid-cols-1 md:grid-cols-12 px-3 pb-6">
            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark">
                DT. Expiração
              </span>
              <div class="text-red-500">
                {{ 
                  beneficiario.controle_registro.length != 0 
                  ? format(new Date(beneficiario.controle_registro.dtexpiracao),"dd/MM/yyyy") 
                  : '-' 
                }}
              </div>
            </div>

            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark"> Situação </span>
              <div
                :style="{
                  color: beneficiario.controle_registro.length != 0 
                  ? getSituation(beneficiario.controle_registro.idsituacao).color 
                  : ''
                }"
              >
                {{
                  beneficiario.controle_registro.length != 0 
                  ? getSituation(beneficiario.controle_registro.idsituacao).label 
                  : '-'
                }}
              </div>
            </div>

            <div class="col-span-8">
              <span class="text-sm form-label text-gray-dark">
                Observação
              </span>
              <div>
                {{    beneficiario.controle_registro.length != 0 ? obs : '-' }}
              </div>
            </div>
          </div>
        </template>

        <div class="lg:max-w-full my-4">
          <div
            class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
          >
            <span class="mt-2 text-base uppercase text-green-base">
              Beneficiário
            </span>
          </div>
        </div>

        <div class="flex space-x-4 px-3 ">
          <div class="flex-1">
            <span class="text-sm form-label text-gray-dark"> CPF </span>
            <span> {{beneficiario.document}}</span>
          </div>
          <div class="flex-1">
            <span class="text-sm form-label text-gray-dark"> Nome </span>
            <span> {{ beneficiario.nmnome }}</span>
          </div>
          <div class="flex-1">
            <span class="text-sm form-label text-gray-dark"> Tipo </span>
            <span> {{ getTypeLabel(beneficiario.tpbeneficiario) }}</span>
          </div>
          <div class="flex-1">
            <span class="text-sm form-label text-gray-dark"> Cidade </span>
            <span> {{ beneficiario.numunicipio.name }}</span>
          </div>
          <div class="flex-1">
            <span class="text-sm form-label text-gray-dark">
              Instituição / Empresa
            </span>
            <span> {{ instituicao.nminstituicao}}</span>
          </div>
        </div>

        <div class="bg-white shadow-lg p-4 m-2">
          <div class="lg:max-w-full my-4">
            <div
              class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
            >
              <span class="mt-2 text-base uppercase text-green-base">
                Informações do passe
              </span>
            </div>
          </div>

          <div class="flex space-x-4 mb-3">
            <div class="w-2/12 flex items-center">
              <span class="text-sm form-label m-0 text-gray-dark">
                Locomoção*
              </span>
            </div>
            <button
              v-if="screenType === 'passes'"
              @click="$refs.passesModal.show()"
              class="flex items-center justify-center form-submit md:w-auto"
              type="button"
            >
              Selecionar passes
            </button>
            <Modal ref="passesModal">
              <div class="flex flex-col justify-center items-center p-6">
                <h1 class="text-center mb-7">
                  Selecione o modelo de passes do beneficiário
                </h1>
                <div class="flex flex-column mb-5">
                  <div v-for="option,index in passesOptions">
                    <input
                      type="radio"
                      name="type"
                      :value="option.name"
                      v-model="selectedOption"
                    >
                    <label>
                      {{ `${option.name} - ${option.types} ${option.quantidade} passes ${index > 2 ? 'cada': ''}` }}
                    </label>
                  </div>
                </div>
                <button
                  class="w-2/4 h-10 justify-center items-center form-submit lg:ml-1"
                  @click="setPasses()"
                >
                  Ok
                </button>
              </div>
            </Modal>
            <div
              v-for="locomocao in tipoLocomocao"
              :key="locomocao.value"
              class="flex items-center space-x-4 w-3/12"
            >
              <hr>
              <label
                :for="locomocao.name"
                class="text-sm form-label m-0 text-gray-dark"
              >
                {{ locomocao.name }}
              </label>
              <span>
                <input
                  v-model="locomocao.selected"
                  :value="locomocao.value"
                  :id="locomocao.name"
                  type="checkbox"
                  @change="updatePasses(locomocao.value)"
                  :disabled="screenType === 'passes'"
                >
              </span>
              <div v-if="screenType === 'passes'" class="">
                <input
                  v-model="locomocao.quantidade"
                  :disabled="true"
                  type="text"
                  size="3"
                  class="h-auto py-2 rounded form-input mb-0"
                  @input="e => updatePassesQuantity(e.target.value, locomocao.value)"
                >
              </div>
            </div>
          </div>
          <div
            v-if="hasErrors && !locomocaoSelecionada"
            class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
          >
            Campo obrigatório
          </div>
          <template v-if="screenType == 'passes'">
            <div class="flex space-x-4 mb-3">
              <div class="w-3/12 flex items-center">
                <span class="text-sm form-label m-0 text-gray-dark">
                  Tipo de passe*
                </span>
              </div>
              <div class="flex items-center space-x-4 w-3/12">
                <hr>
                <span>
                  <input
                    v-model="tpPasseSelecionado"
                    :value="1"
                    type="radio"
                    name="tipoPasse"
                  >
                </span>
                <label class="text-sm form-label m-0 text-gray-dark">
                  Físico
                </label>
              </div>
              <div class="flex items-center space-x-4 w-3/12">
                <hr>
                <span>
                  <input
                    v-model="tpPasseSelecionado"
                    :value="2"
                    type="radio"
                    name="tipoPasse"
                  >
                </span>
                <label class="text-sm form-label m-0 text-gray-dark">
                  Eletronico
                </label>
              </div>
            </div>
            <div class="flex space-x-4 mb-2 ">
              <div class="col-span-4 flex justify-start items-center">
                <span class="text-sm form-label m-0 text-gray-dark">
                  Quantidade de passes máximo:
                  <b>{{ passeForm.quantidade }}</b>
                </span>
                <!-- <div class="ml-2">
                  <input
                    v-model="passeForm.quantidade"
                    type="number"
                    size="3"
                    class="h-auto py-2 rounded form-input mb-0"
                    :class="{
                      'bg-red-100 border-red-400':
                      hasErrors &&
                      !passeForm.quantidade
                    }"
                  >
                  <div
                    v-if="hasErrors && !passeForm.quantidade"
                    class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                  >
                    Campo obrigatório
                  </div>
                </div> -->
              </div>
              <div class="col-span-4 flex justify-start items-center">
                <div class="mr-2">
                  <input
                    type="radio"
                    name="quantidade"
                    :value="0"
                    @change="setPassesOptions()"
                    v-model="passeForm.jornada12x36"
                    class="h-auto py-2 rounded mb-0"
                  >
                </div>

                <span class="text-sm form-label m-0 text-gray-dark">
                  Jornada integral
                </span>
              </div>
              <div class="col-span-4 flex justify-start items-center">
                <div class="mr-2">
                  <input
                    type="radio"
                    name="quantidade"
                    :value="1"
                    @change="setPassesOptions()"
                    v-model="passeForm.jornada12x36"
                    class="h-auto py-2 rounded mb-0"
                  >
                </div>

                <span class="text-sm form-label m-0 text-gray-dark">
                  Jornada 12x36
                </span>
              </div>
              <div class="col-span-4 flex justify-start items-center">
                <div class="mr-2">
                  <input
                    type="radio"
                    name="quantidade"
                    :value="2"
                    @change="setPassesOptions()"
                    v-model="passeForm.jornada12x36"
                    class="h-auto py-2 rounded mb-0"
                  >
                </div>

                <span class="text-sm form-label m-0 text-gray-dark">
                  Jornada 2 semanas
                </span>
              </div>
            </div>
          </template>
          <div class="lg:max-w-full my-4">
            <div
              class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
            >
              <span class="mt-2 text-base uppercase text-green-base">
                Observações
              </span>
            </div>
          </div>

          <div class="flex items-center space-x-4 mt-2 mb-4">
            <div class="flex space-x-2">
              <span>
                <input
                  v-model="ispendencia"
                  :value="ispendencia ? true : false"
                  id="pendencia"
                  type="checkbox"
                >
              </span>
              <label for="pendencia" class="text-sm form-label text-gray-dark">
                Pendência
              </label>
            </div>
          </div>
          <template v-if="screenType == 'passes'">
            <div class="flex items-center space-x-4 mt-2 mb-4">
              <div class="w-full">
                <textarea
                  v-model="obs"
                  maxlength="255"
                  class="py-2 rounded form-input"
                  row="20"
                  style="max-height: 200px; min-height: 200px;"
                  placeholder="Escreva aqui sua observação"
                ></textarea>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="flex items-center space-x-4 mt-2 mb-4">
              <div class="w-full">
                <textarea
                  v-model="obs_pendencia"
                  :disabled="!ispendencia"
                  maxlength="255"
                  class="py-2 rounded form-input"
                  row="20"
                  style="max-height: 200px; min-height: 200px;"
                  placeholder="Escreva aqui sua observação"
                ></textarea>
              </div>
            </div>
          </template>

          <div
            class="flex flex-col space-y-4 lg:items-center lg:flex-row lg:space-y-0 lg:space-x-4 justify-between"
          >
            <div
              class="flex flex-col space-y-4 lg:items-center lg:flex-row lg:space-y-0 lg:space-x-4"
            >
              <button
                @click="goBack"
                type="button"
                class="flex items-center justify-center py-2 form-submit md:w-auto"
                style="background: #828282"
              >
                Voltar
              </button>
              <button
                type="button"
                class="flex items-center justify-center py-2 form-submit md:w-auto"
                @click.prevent="$refs.modal.showModal()"
              >
                Confirmar
              </button>
            </div>
            <div style="color: #029E4D">Passo 3 de 3</div>
          </div>
        </div>

        <template v-if="screenType == 'passes' && passes.length > 0">
          <div class="lg:max-w-full my-4">
            <div
              class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
            >
              <span class="mt-2 text-base uppercase text-green-base">
                Histórico de passes do beneficiário
              </span>
            </div>
          </div>
          <div class="px-2 pb-4">
            <ResponsiveTable
              :headers="headers"
              :data="dataMap(passes)"
              :pagination="pagination"
              :disabled="loading"
              :status="status"
              @changePage="page => { changePage(page) ;}"
            >
              <template #row="props">
                <td :class="props.tdClass">{{ props.row.mesvigencia }}</td>
                <td :class="props.tdClass">{{ props.row.quantidade }}</td>
                <td :class="props.tdClass">
                  {{ props.row.tipo_beneficiario }}
                </td>
                <td :class="props.tdClass">{{ props.row.empresa }}</td>
                <td :class="props.tdClass">{{ props.row.dt_entrega }}</td>
                <td :class="props.tdClass">{{ props.row.observacao }}</td>
              </template>
            </ResponsiveTable>
          </div>
        </template>
      </div>
    </div>

    <dialog ref="modal">
      <template v-if="ispendencia">
        <h3>Confirmar pendência do(a) {{ beneficiario.nmnome }}?</h3>
      </template>
      <template v-if="screenType == 'passes'">
        <h3>
          Confirmar a entrega de {{ passeForm.quantidade }}passes do(a)
          {{ beneficiario.nmnome }}?
        </h3>
      </template>

      <!-- <template
        v-if="screenType == 'passes' && this.passes_total.length > 0 && this.passes[0] != null "
      >
        <h3 style="color: red;">
          Existe uma entrega de {{ this.passes[0].nupasses }}passes.
        </h3>
      </template> -->

      <template v-if="screenType == 'document' || screenType == undefined">
        <h3>
          Confirmar a entrega de documentos do(a)
          {{ beneficiario.nmnome }}?
        </h3>
      </template>
      <template
        v-if="screenType == 'passes' && this.passes_total.length > 0 && this.passes[0] != null && this.passes[0].nupasses != null"
      >
        <h3 style="color: red;">
          Existe uma entrega de {{ this.passes[0].nupasses }}passes.
        </h3>
      </template>
      <div
        class="mt-4 flex items-center justify-center flex-col space-y-4 lg:items-center lg:flex-row lg:space-y-0 lg:space-x-4"
      >
        <button
          type="button"
          class="flex items-center justify-center py-2 form-submit md:w-auto"
          style="background: #828282"
          @click.prevent="$refs.modal.close()"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="flex items-center justify-center py-2 form-submit md:w-auto"
          @click.prevent="$refs.modal.close(); submit();"
        >
          Confirmar
        </button>
      </div>
    </dialog>
  </div>
</template>
<style scoped>
  dialog {
    border: 2px solid #029e4d;
    background: white;
    outline: none;
  }

  dialog::backdrop {
    background: #c0c0c080;
  }

  h3 {
    color: #029e4d;
    font-weight: 900;
    font-size: 30px;
    text-align: center;
  }
</style>
